import { IRootState } from '..'

export const getContact = (state: IRootState, id: string) =>
  state.userState.contacts.filter(contact => contact.id === id)[0]

export const getMember = (state: IRootState, id: string) =>
  state.userState.members.filter(member => member.id === id)[0]

export const getProjects = (state: IRootState) => state.userState.projects
